import Vue from 'vue';

import {
  AUTH_LOADING_SET,
  AUTH_PTF_TOKEN_SET,
  AUTH_ROUTES_SET,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_ERROR_SET,
  AUTH_USER_SET,
} from '../mutations-types'

const state = {
  isHasPTFToken: !!localStorage.getItem('ptf_token'),
  isAuthLoading: false,
  authSaveRoutes: null,
  user: (localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')) : null,
  message: null
};

const getters = {
  isHasPTFToken: state => state.isHasPTFToken,
  isAuthLoading: state => state.isAuthLoading,
  isAuthError: state => state.isAuthError,
  authSaveRoutes: state => state.authSaveRoutes,
  user: state => state.user,
  authStatus: state => state.authStatus,
};

const mutations = {
  [AUTH_PTF_TOKEN_SET](state, token) {
    if (token) {
      localStorage.setItem('ptf_token',token)
      Vue.set(state, 'isHasPTFToken', true);
    } else {
      localStorage.removeItem('ptf_token');
      Vue.set(state, 'isHasPTFToken', false);
    }
  },

  [AUTH_ROUTES_SET](state, routes) {
    Vue.set(state, 'authSaveRoutes', routes);
  },

  [AUTH_LOADING_SET](state, flag) {
    Vue.set(state, 'isAuthLoading', flag);
  },

  [AUTH_LOGIN](state, token) {
    localStorage.setItem('access_token',token)
  },

  [AUTH_USER_SET](state, data) {
    if (data) {
      data.enablePtfSalesView = 1;
    }
    localStorage.setItem('user', JSON.stringify(data))
    Vue.set(state, 'user', data);
  },

  [AUTH_LOGOUT](state) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    Vue.set(state, 'user', null);
  },

  [AUTH_ERROR_SET](state, flag) {
    Vue.set(state, 'isAuthError', flag);
  },
};

const actions = {
  /**
   * @URLParams
   * token: string, required
   * @BodyParams
   * none
   * **/
  AUTH_LOGIN_REQUEST ({ state, commit, dispatch }) {
    commit(AUTH_ERROR_SET, false);
    return new Promise((resolve, reject) => {
      if (state.isHasPTFToken) {
        commit(AUTH_LOADING_SET, true);
        let ptf_token = localStorage.getItem('ptf_token')
        Vue.axios.post('/auth/login', {
          token: ptf_token
        }).then(response => {
          commit(AUTH_LOGIN, response.data.access_token);
          dispatch('AUTH_GET_USER').then(() => {
            resolve();
          }).catch(error => {
            reject();
            commit(AUTH_LOGOUT);
            commit(AUTH_ERROR_SET, true);
          }).finally(()=>{
            commit(AUTH_LOADING_SET, false);
          });

        }).catch(error => {
          if (error.response.status === 418) {
            commit(AUTH_PTF_TOKEN_SET, null);
            resolve();
          } else {
            commit(AUTH_ERROR_SET, true);
            reject();
          }
          commit(AUTH_LOGOUT);
          commit(AUTH_LOADING_SET, false);
        });
      } else {
        commit(AUTH_LOGOUT);
        resolve();
      }
    });
  },

  /**
   * @note
   * local Promise
   * @URLParams
   * none
   * @BodyParams
   * none
   * **/
  AUTH_LOGOUT_REQUEST ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT);
      resolve();
    });
  },

  /**
   * @note
   * require auth
   * @URLParams
   * none
   * @BodyParams
   * none
   * **/
  AUTH_GET_USER ({ state, commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('/user')
        .then(response => {
          commit(AUTH_USER_SET, response.data);
          resolve();
      }).catch(error => {
        reject();
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};